import { Component, OnInit } from '@angular/core';
import { HttpService } from '../../http.service';
import { CircularComponent } from '../circular/circular.component';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css'],
  providers: [HttpService]
})
export class AboutComponent implements OnInit {
  title = 'Simple Server side Angular 2 pagination';
  users = [];
  totalItem = '';
  clickTime:number = 0;
  ifElseCondition = true;

  constructor(
		private httpService : HttpService
	){
		this.getServerData(1);
  }


  ngOnInit() {
  }

  public getServerData(event){
		this.httpService.getdata(event).subscribe(
			response =>{
				if(response.error) {
				//	alert('Server Error');
				} else {
					this.users = response.users;
          this.totalItem = response.totalCount;
         // alert(response.totalCount);
				}
			},
			error =>{
				alert('Server errors');
			}
		);
		return event;
	}

  data:number[] =[1,2,3,4,5,66]

  getServiceProviders(event){
    console.log(event.target)
    this.clickTime++;
  }

  recentaddedMovie = 'none'
  cart = [];
  selectedNumber(movie){
    this.recentaddedMovie = movie;
    this.cart.push(movie);
    alert(this.recentaddedMovie+' added to cart');
  }

}



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/_components/about/about.component.ts